import React, { useMemo } from 'react';
import clsx from 'clsx';
import { LibraryBookCovers } from '@/api/types';
import { Image } from './Image';

interface BookMediaProps {
  className?: string;
  bookCover?: LibraryBookCovers;
  altText?: string;
}

const getBookCoverSrc = (bookCover: LibraryBookCovers) => {
  const src =
    bookCover.original ||
    bookCover.extraLarge ||
    bookCover.large ||
    bookCover.medium ||
    bookCover.small ||
    bookCover.extraSmall ||
    bookCover.tiny;

  return src;
};

export const BookMedia = ({
  className,
  bookCover,
  altText,
}: BookMediaProps) => {
  const src = useMemo(
    () => bookCover && getBookCoverSrc(bookCover),
    [bookCover],
  );

  return (
    <div className={clsx('aspect-[6/9] relative w-full', className)}>
      {src ? (
        <Image
          className="rounded-xl w-full h-full object-cover"
          src={src}
          alt={altText || ''}
          fill
          priority
        />
      ) : (
        'No book cover found'
      )}
    </div>
  );
};
